// extracted by mini-css-extract-plugin
module.exports = {"root":"InsightsDetailTable_root__x2ZlG","headerCell":"InsightsDetailTable_headerCell__P9m5E","cell":"InsightsDetailTable_cell__1Fc9u"};